import { render, staticRenderFns } from "./review-select.dialog.vue?vue&type=template&id=75c44b8f&scoped=true"
import script from "./review-select.dialog.vue?vue&type=script&lang=js"
export * from "./review-select.dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c44b8f",
  null
  
)

export default component.exports